import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/admin/holidays/holidays-client.tsx");
